import { render, staticRenderFns } from "./AccountDomainSettingsView.vue?vue&type=template&id=7a597a0c&"
import script from "./AccountDomainSettingsView.vue?vue&type=script&lang=js&"
export * from "./AccountDomainSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a597a0c')) {
      api.createRecord('7a597a0c', component.options)
    } else {
      api.reload('7a597a0c', component.options)
    }
    module.hot.accept("./AccountDomainSettingsView.vue?vue&type=template&id=7a597a0c&", function () {
      api.rerender('7a597a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/account/AccountDomainSettingsView.vue"
export default component.exports